import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingAnimation from './LoadingAnimation';
import Footer from './Footer';

const Reflections = () => {
  const navigate = useNavigate();
  const [reflections, setReflections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReflections = async () => {
      try {
        const q = query(collection(db, 'reflections'), orderBy('created_at', 'desc'));
        const snap = await getDocs(q);
        const now = new Date();
        setReflections(snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(r => {
            const status = r.status || 'published';
            if (status === 'deleted' || status === 'draft') return false;
            if (status === 'scheduled' && r.scheduled_at && r.scheduled_at.toDate() > now) return false;
            return true;
          })
        );
      } catch (err) {
        console.error('Error fetching reflections:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchReflections();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="stt-page">
      <div className="stt-content" style={{ paddingTop: '40px', paddingBottom: '60px' }}>
        <h1 className="stt-page-title">Reflections</h1>
        <hr className="divider-gold" style={{ margin: '0 0 32px' }} />

        {loading ? (
          <LoadingAnimation />
        ) : reflections.length === 0 ? (
          <p style={{ color: '#888' }}>No reflections yet. Check back soon.</p>
        ) : (
          reflections.map(reflection => (
            <div
              key={reflection.id}
              className="stt-reflection-item"
              onClick={() => navigate(`/reflections/${reflection.id}`)}
            >
              <p className="stt-reflection-title">{reflection.title}</p>
              <p className="stt-reflection-meta">
                {reflection.author && `By ${reflection.author}`}
                {reflection.author && reflection.created_at && ' · '}
                {formatDate(reflection.created_at)}
              </p>
              {reflection.summary && (
                <p className="stt-reflection-summary">{reflection.summary}</p>
              )}
            </div>
          ))
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Reflections;
